export function getValueInputRef(ref: any) {
  let formData: any = {}

  ref?.current.find((ref) => {
    let { id, value } = ref
    formData[id] = value
  })

  return formData
}